"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Browser = void 0;
const tslib_1 = require("tslib");
const utils_1 = tslib_1.__importDefault(require("../utils"));
class Browser {
    /**
     * Detect if FIDO2 supported
     * @returns {Promise<boolean>}
     * */
    isFido2Supported() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            try {
                if (!window.PublicKeyCredential || !window.PublicKeyCredential.isUserVerifyingPlatformAuthenticatorAvailable) {
                    return false;
                }
                return yield window.PublicKeyCredential.isUserVerifyingPlatformAuthenticatorAvailable();
            }
            catch (err) {
                return false;
            }
        });
    }
    /**
     * Handler to abstract the interaction with AuthID iFrame flow for Proof and Verify.
     * @returns {Promise<void>}
     * */
    authidIframeHandler(element, src) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            return yield utils_1.default.authidIframeHandler(element, src);
        });
    }
}
exports.Browser = Browser;
exports.default = Browser;
//# sourceMappingURL=index.js.map